import React, { useState } from 'react';
import { Modal, Typography } from 'amphitheatre';
import styled from 'styled-components';

const { Paragraph } = Typography;

const Wrapper = styled.div`
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .image {
    border-bottom: 2px solid ${({ theme }) => theme.grey700};
    cursor: pointer;
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    .image-modal {
      width: 85vw;
      min-width: 85vw;
      height: 95vh;
      min-height: 95vh;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 10000;
    }

    .desktop {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
`;

interface Props extends React.HTMLAttributes<HTMLImageElement> {
  alt?: string;
  src?: string;
}

const ImagePopup: React.FunctionComponent<Props> = ({ alt, src }: Props) => {
  const [show, setShow] = useState(false);

  function close() {
    setShow(!show);
  }

  return (
    <Wrapper>
      <img className="image" src={src} alt={alt} onClick={close} />
      <Modal
        className="image-modal"
        cancel={close}
        footer={<></>}
        visible={show}
      >
        <div className="desktop">
          <img src={src} style={{ height: '100%', width: '100%' }} alt={alt} />
        </div>
        <div className="mobile">
          <Paragraph style={{ color: 'white', marginTop: '1rem' }}>
            You can get a more detailed view of the image by zooming into the
            screen using your two fingers!
          </Paragraph>
        </div>
      </Modal>
    </Wrapper>
  );
};

export default ImagePopup;
